import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Alert, Card, Row, Col } from 'react-bootstrap';
import { getContracts, createContract, updateContract } from '../api';

const ContractsView = () => {
    const [contracts, setContracts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingContractId, setEditingContractId] = useState(null);
    const [newContract, setNewContract] = useState({
        name: '',
        type: 'FIJO', // FIJO, VARIABLE
        percentage_1: 77,
        percentage_2: 70,
        threshold: 100000
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => { loadContracts(); }, []);

    const loadContracts = async () => {
        try { setContracts(await getContracts()); } catch (err) { console.error(err); }
    };

    const handleOpenModal = (contract = null) => {
        setError('');
        setSuccess('');
        if (contract) {
            setNewContract({
                name: contract.name,
                type: contract.type,
                percentage_1: contract.percentage_1,
                percentage_2: contract.percentage_2,
                threshold: contract.threshold
            });
            setEditingContractId(contract.id);
        } else {
            setNewContract({
                name: '',
                type: 'FIJO',
                percentage_1: 77,
                percentage_2: 70,
                threshold: 100000
            });
            setEditingContractId(null);
        }
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            const payload = {
                ...newContract,
                percentage_1: parseFloat(newContract.percentage_1),
                percentage_2: parseFloat(newContract.percentage_2),
                threshold: parseFloat(newContract.threshold)
            };
            if (editingContractId) {
                await updateContract(editingContractId, payload);
                setSuccess('Contrato actualizado correctamente');
            } else {
                await createContract(payload);
                setSuccess('Contrato creado correctamente');
            }
            setShowModal(false);
            setNewContract({ name: '', type: 'FIJO', percentage_1: 77, percentage_2: 70, threshold: 100000 });
            setEditingContractId(null);
            loadContracts();
        } catch (err) {
            setError(editingContractId ? 'Error al actualizar el contrato.' : 'Error al crear el contrato.');
        }
    };

    return (
        <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Tipos de Contrato</h3>
                <Button variant="primary" onClick={() => handleOpenModal(null)}>+ Nuevo Contrato</Button>
            </div>

            {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}
            {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}

            <Card className="shadow-sm">
                <Table hover responsive className="align-middle">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            <th>Reglas (Si es Variable)</th>
                            <th className="text-end" style={{ width: '150px' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contracts.map((c) => (
                            <tr key={c.id}>
                                <td>{c.name}</td>
                                <td>{c.type}</td>
                                <td>
                                    {c.type === 'VARIABLE' ? (
                                        <small>
                                            {c.percentage_1}% si &lt; ${c.threshold.toLocaleString()} <br/>
                                            {c.percentage_2}% si &ge; ${c.threshold.toLocaleString()}
                                        </small>
                                    ) : '-'}
                                </td>
                                <td className="text-end">
                                    <Button variant="outline-primary" size="sm" onClick={() => handleOpenModal(c)}>
                                        Editar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingContractId ? 'Editar Tipo de Contrato' : 'Nuevo Tipo de Contrato'}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control type="text" required placeholder="Ej. Variable 23/30" value={newContract.name} onChange={(e) => setNewContract({...newContract, name: e.target.value})} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tipo</Form.Label>
                            <Form.Select value={newContract.type} onChange={(e) => setNewContract({...newContract, type: e.target.value})}>
                                <option value="FIJO">Fijo (Pago Manual por Viaje)</option>
                                <option value="VARIABLE">Variable (Porcentaje Automático)</option>
                            </Form.Select>
                        </Form.Group>
                        
                        {newContract.type === 'VARIABLE' && (
                            <div className="p-3 bg-light rounded">
                                <h6 className="text-muted">Reglas de Cálculo</h6>
                                <Row>
                                    <Col md={12} className="mb-2">
                                        <Form.Label>Monto de Corte ($)</Form.Label>
                                        <Form.Control type="number" value={newContract.threshold} onChange={(e) => setNewContract({...newContract, threshold: e.target.value})} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>% Tramo Bajo</Form.Label>
                                        <Form.Control type="number" value={newContract.percentage_1} onChange={(e) => setNewContract({...newContract, percentage_1: e.target.value})} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>% Tramo Alto</Form.Label>
                                        <Form.Control type="number" value={newContract.percentage_2} onChange={(e) => setNewContract({...newContract, percentage_2: e.target.value})} />
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
                        <Button variant="primary" type="submit">Guardar</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

export default ContractsView;
